import { ProductList } from "../../../../Common/Constant";

const defaultBenefitDurationList = () => {
  return [
    {label: "2 Years", value: "2"},
    {label: "3 Years", value: "3"},
    {label: "4 Years", value: "4"},
    {label: "5 Years", value: "5"},
    {label: "6 Years", value: "6"},
    {label: "7 Years", value: "7"},
    {label: "8 Years", value: "8"},
  ];
}

const defaultPremiumModeList = () => {
  return [
    {label: "Single Pay", value: "Single Pay"},
    {label: "2 Pay", value: "2 Pay"},
    {label: "3 Pay", value: "3 Pay"},
    {label: "4 Pay", value: "4 Pay"},
    {label: "5 Pay", value: "5 Pay"},
    {label: "7 Pay", value: "7 Pay"},
    {label: "10 Pay", value: "10 Pay"},
    {label: "15 Pay", value: "15 Pay" },
    {label: "20 Pay", value: "20 Pay"},
    {label: "Pay to 65", value: "Pay to 65"},
    {label: "Pay to 100", value: "Pay to 100"},
  ];
}

const setPremiumModeOptions = (value, list, updateList, isOwner, insuredAge, residentState) => {
  let modeList = [];

  if ((value.toLowerCase().indexOf(ProductList.BRIGHTHOUSE_SMART_CARE.toLowerCase()) !== -1)) {
    modeList = (residentState === 'NY' || residentState === 'MT') ? list.filter(data => data.value !== '7 Pay' && data.value !== '10 Pay' && data.value !== 'Pay to 65' && data.value !== 'Pay to 100')
      : list.filter(data => data.value !== '7 Pay' && data.value !== 'Pay to 65' && data.value !== 'Pay to 100');
  } else if (value.toLowerCase().indexOf(ProductList.NATIONWIDE_CARE_MATTERS_TWO.toLowerCase()) !== -1) {
    if (((isOwner && insuredAge > 99) || (!isOwner && insuredAge > 75))) {
      modeList = list.filter(data => data.value !== 'Single Pay');
    }

    modeList = list.filter(data => data.value !== '2 Pay'
      && data.value !== '3 Pay' && data.value !== '4 Pay' && data.value !== '7 Pay');

    if (((isOwner && insuredAge > 75) || (!isOwner && insuredAge > 75))) {
      modeList = list.filter(data => data.value !== '5 Pay' && data.value !== '10 Pay');
    }

    if ((insuredAge >= 55)) {
      modeList = list.filter(data => data.value !== 'Pay to 65' && data.value !== 'Pay to 100');
    }
  } else {
    modeList = list;
  }

  updateList(modeList);
}

const setBenefitDurationOptions = (value, list, updateList) => {
  if (value.toLowerCase().indexOf(ProductList.NATIONWIDE_CARE_MATTERS_TOGETHER.toLowerCase()) !== -1){
    updateList(list);
  } else if ((value.toLowerCase().indexOf(ProductList.NATIONWIDE_CARE_MATTERS.toLowerCase()) !== -1)
    || (value.toLowerCase().indexOf(ProductList.NATIONWIDE_CARE_MATTERS_TWO.toLowerCase())) !== -1) {
    const benefitList = list.filter(data => data.value !== '8');
    updateList(benefitList);
  } else if (value.toLowerCase().indexOf(ProductList.BRIGHTHOUSE_SMART_CARE.toLowerCase()) !== -1) {
    const benefitList = list.filter(data => data.value !== '2' && data.value !== '3' && data.value !== '5' && data.value !== '7' && data.value !== '8');
    updateList(benefitList);
  } else if (value.toLowerCase().indexOf(ProductList.LINCOLN_MGMA.toLowerCase()) !== -1) {
    const benefitList = list.filter(data => data.value !== '2' && data.value !== '4' && data.value !== '5' && data.value !== '6' && data.value !== '7' && data.value !== '8');
    updateList(benefitList);
  } else if ((value.toLowerCase().indexOf(ProductList.LINCOLN_MG_II.toLowerCase()) !== -1) ||
    (value.toLowerCase().indexOf(ProductList.LINCOLN_MGFA.toLowerCase()) !== -1)) {
    const benefitList = list.filter(data => data.value !== '2' && data.value !== '8');
    updateList(benefitList);
  } else {
    updateList(list);
  }
}

const eliminationPeriodOptions = [
  { label: '30 Days', value: '30 Days' },
  { label: '60 Days', value: '60 Days' },
  { label: '90 Days', value: '90 Days' },
  { label: '180 Days', value: '180 Days' },
  { label: '365 Days', value: '365 Days' },
]

const benefitPeriodOptions = [
  { label: '1 year', value: '1 year' },
  { label: '2 years', value: '2 years' },
  { label: '5 years', value: '5 years' },
  { label: '10 years', value: '10 years' },
  { label: 'To age 65', value: 'To age 65' },
  { label: 'To age 67', value: 'To age 67' },
  { label: 'To age 70', value: 'To age 70' },
  { label: 'Other', value: 'Other' },
]

export { defaultBenefitDurationList, defaultPremiumModeList, setPremiumModeOptions, setBenefitDurationOptions, eliminationPeriodOptions, benefitPeriodOptions };


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/SelectProduct/Helpers/Lists.js